import { navigateToObjectTool } from './navigateToObjectTool'
import { globalSearchTool } from './globalSearchTool'
import { sendEmailTool } from './sendEmailTool'
import { makePhoneCallTool } from './makePhoneCallTool'
import { sendSMSTool } from './sendSMSTool'

export const tools = {
  'navigate-to-object': navigateToObjectTool,
  'send-sms': sendSMSTool,
  'global-search': globalSearchTool,
  'send-email': sendEmailTool,
  'make-phone-call': makePhoneCallTool,
}
